const config = {
  draggable: '.slot.draggable',
  dropzone: '.dropzone',
  handle: '.drag-handle',
  distance: 10,
  delay: {
    mouse: 0,
    drag: 0,
    touch: 100
  },
  mirror: {
    constrainDimensions: true,
    cursorOffsetX: 0,
  }
};

export default config;

export const templateSectionConfig = {
  draggable: '#role-section-template-list .draggable',
  distance: 10,
  mirror: { 
    constrainDimensions: true,
  }
};

export const sectionConfig = {
  draggable: '.section.draggable',
  distance: 10,
  mirror: {
    appendTo: document.body,
    constrainDimensions: true,
  }
};

export const templateRoleConfig = {
  draggable: '#role-template-list .draggable',
  distance: 10,
  mirror: { 
    constrainDimensions: true,
  }
};
